import React, { useEffect } from 'react'
import { useState } from 'react'
import '../Feed.css'
import Postbox from './Postbox'
import Post from './Post'
import { db } from '../Firebase/init'
import { collection, onSnapshot } from 'firebase/firestore'
import { AnimatePresence, motion } from 'framer-motion'


function Feed() {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        const postRef = collection(db, 'posts') /* this works because we only have one document always so we dont need anything else and we can just get the whole collection called 'posts' just to get our postRef so don't really think of this pattern as the norm as it almost never is */
            const replacePost = onSnapshot(postRef, snapshot => {
        setPosts(snapshot.docs.map(doc => ({...doc.data(), id:doc.id})))
    })
    return () => replacePost()
},[posts])          /* Mapping every array(doc) that's added;### TO our posts array/state;### so now our posts array has a new post as its item and when a new doc gets added into the db, we get a new item inside the same index (0) obviously nothing adds to it only replaces the previous doc*/

  return (
    <div className="feed">
        <div className="feed__header">
            <span className='feed__header__item--active'>For you</span>
            <span className='feed__header__item'>Following</span>
        </div>
            <Postbox />
            <AnimatePresence>
            {posts.map(post => ( 
            <motion.div
            key={post.id}
            layout
            initial={{opacity: 0, y: 10}}
            animate={{ opacity: 1, y: 0}}
            exit={{ opacity: 0, y: -10}}
            >
                <Post
                avatar={post.avatar}
                displayName={post.displayName}
                userName={post.userName}
                media={post.media}
                verified={post.verified}
                caption={post.caption}
                />
                </motion.div>
            ))} 
            </AnimatePresence>
            {/* obviously each item inside the array is a property in the db###; since the item inside the array is a single object; so yeah### all we're doing is accessing the only key for each post (object) inside the posts array */}
           <Post displayName="Salmon Vulcan" userName="salmonella_vol1" caption="☕🤮😑" avatar = "https://i.redd.it/2mxejivbvvf61.jpg" media="https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExc2Q3em54NGlyZGNpNGQ1OHkzZGczeGRqbHdzOW84bTVwNzJqbnI4NiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/Ym7JUEUTAyFSTJLc4K/giphy.gif" />

           <Post displayName="Pepe" userName="pepe_onions55" verified caption="Gmail every time I login from a new window" avatar = "https://i.pinimg.com/236x/43/d1/1f/43d11f461df5606a9d5219c2ec657de7.jpg" media="https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExaDFzaWJvOW1lb3M3eG8xZWNpbXo2eDFjY2hxMThldDg5MWJobTg2MSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/l0IylOPCNkiqOgMyA/giphy.gif" />
           
           <Post displayName="Ramesh Adh" userName="ramesh_adhk23" verified caption="Lifting💪🏻" avatar = "https://i.pinimg.com/236x/d4/c9/6c/d4c96c045c08db2b3e54861d16e3a93c.jpg" media="https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExb3g1NnI3c2Rjb25xdmlsbzF0NjdoY2h5ZDZicmpnNHRyY2ZlZWplZiZlcD12MV9naWZzX3NlYXJjaCZjdD1n/3oriNZoNvn73MZaFYk/100.webp" />
           
           <Post displayName="Mr Pongang" userName="mr_pingpong32" verified caption="Anyone awake?🫥" avatar = "https://i.pinimg.com/236x/33/d2/9b/33d29ba54bd96b5379c1820d9d8c7422.jpg" media="https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExaTRmN3lrMm4yempzdzM2enc4N290cGFneG1zYXpsNDlzZGF4dDIzMiZlcD12MV9naWZzX3NlYXJjaCZjdD1n/nXUCkgH6BmigU/200w.webp" />
    </div>
  )
}

export default Feed